module.exports = __webpack_public_path__ + "img/dy111.118fee05.png";